import * as React from 'react'
import { Button, Form, Image, Spinner } from 'react-bootstrap'
import _ from 'lodash'
import ButtonUploadImage from '../../components/ButtonUploadImage'
import images from '../../constants/images'
import { useSelector } from 'react-redux'
import {  uploadFileServer } from '../../utils/RequestMethods'
import config from '../../constants/config'
import { UserT, initUserObj } from '../../types/Users'
import { copyObject } from '../../utils'
import InputPhone from '../../components/InputPhone'
import ButtonLoading from '../../components/ButtonLoading/ButtonLoading'
import GoogleMapAutoComplete from '../../components/MapBoxAutoComplete/GoogleMapAutoComplete'

const colors = {
    red: "#cc0000",
    green: "#198c19",
}

interface AccountSettingsProps {
    user: UserT
    saveCurrentUser(params): Promise<UserT>
}


const AccountSettings: React.FunctionComponent<AccountSettingsProps> = ({ user, saveCurrentUser }): JSX.Element => {
    const [dirty, setDirty] = React.useState({});
    const [fileLogo, setFileLogo] = React.useState(null)

    // let auth = useSelector(state => state.auth)


    const updateDirty = (key: string, value: any): void => {
        let cloneDirty = copyObject(dirty)
        cloneDirty[key] = value
        setDirty(cloneDirty)
    }


    const save = async (params): Promise<string> => {
        if (!params) {
            params = {}
        }

        try {
            let res = await saveCurrentUser(params)
            if (res) {

                return 'User saved.'
            }
        } catch (error) {
            throw new Error(error)

        }
    }


    const saveProfilePicture = async (event): Promise<string> => {
        try {
            const res = await uploadFileServer(fileLogo)
            if (res.source_url) {
                updateDirty('profilePic', res.source_url)
                let params = {
                    profilePic: res.source_url
                }
                const resSave = await save(params)
                if (resSave) {
                    setTimeout(() => {
                        setFileLogo(null)
                    }, 1000);
                    return "Profile Pic saved."
                }
            }
        } catch (error) {
            throw new Error(error)
        }
    }

    return (
        <div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 3fr' }}>
                <span>

                    <Image
                        src={fileLogo && fileLogo.uri ? fileLogo.uri : user.profilePic != '' ? user.profilePic : images.noProfilePic}
                        style={{ width: 200, height: 200 }} />
                    <br />

                    <ButtonUploadImage
                        type="button"

                        accept={"image/png, image/jpeg"}
                        className="btn-link  mt-2"
                        onChangeFile={(file) => {
                            setFileLogo(file)
                        }}>
                        Update Profile Pic
                    </ButtonUploadImage>
                    {fileLogo && <div>
                        <Button variant="light"
                            onClick={() => {
                                setFileLogo(null)
                            }}>
                            Cancel</Button>
                        <ButtonLoading
                            className="btn-primary"
                            onClickFetching={saveProfilePicture}>
                            Save</ButtonLoading>
                    </div>}

                </span>


                <span style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                    <span>
                        <Form.Label>First Name</Form.Label>
                        <Form.Control
                            value={`${_.has(dirty, "firstName") ? dirty['firstName'] : user.firstName}`}
                            className='input-material'
                            onChange={(event) => {
                                updateDirty('firstName', event.target.value)
                            }}
                        />
                    </span>
                    <span>
                        <Form.Label>Last Name</Form.Label>
                        <Form.Control
                            className='input-material'
                            value={`${_.has(dirty, "lastName") ? dirty['lastName'] : user.lastName}`}
                            onChange={(event) => {
                                updateDirty('lastName', event.target.value)
                            }}
                        />
                    </span>
                    <span>
                        <Form.Label>Phone</Form.Label>
                        <InputPhone
                            className="input-material"
                            defaultValue={`${_.has(dirty, "phone") ? dirty['phone'] : user.phone}`}
                            value={`${_.has(dirty, "phone") ? dirty['phone'] : user.phone}`}
                            onChangeValue={val => { updateDirty('phone', val) }} />
                    </span>
                    <span>
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            // disabled={true}
                            value={`${_.has(dirty, "email") ? dirty['email']: user.email}`}
                            className='input-material'
                            onChange={(event) => {
                                updateDirty('email', event.target.value)
                            }}
                        />
                    </span>
                </span>
                <span></span>
                <div style={{ display: 'grid', gridTemplateColumns: '4fr 1fr' }}>
                    <span>
                        <Form.Label>Address</Form.Label>

                        <GoogleMapAutoComplete
                        idAddresss="account-address"
                            className='input-material'
                            apiKey={config.keyMap}
                            onChangeText={text => { }}
                            onPress={async location => {
                                updateDirty('address', location.verbose_address)

                            }}
                            placeholder=''
                            textValue={`${_.has(dirty, "address") ? dirty['address'] : user.address}`}
                        />

                    </span>
                    <span>
                        <Form.Label>Address 2</Form.Label>
                        <Form.Control
                            value={`${_.has(dirty, "address2") ? dirty['address2']: user.address2}`}
                            className='input-material'
                            onChange={(event) => {
                                updateDirty('address2', event.target.value)
                            }}
                        />
                    </span>
                    <span>
                        <ButtonLoading
                            /*className="btn-primary"*/
                            className='btn-success'
                            onClickFetching={async (e): Promise<string> => {
                                let params = { ...dirty }
                                return await save(params)
                            }} >
                            Save
                    </ButtonLoading>
                    </span>
                </div>
            </div>
        </div>
    )
}

export default AccountSettings
